import { useParsePublicUrls } from '~/composables/useParsePublicUrls'

export const parseProtocol = (urlRaw: string): string => {
  const { parsePublicUrls } = useParsePublicUrls()

  const validProtocols = ['http:', 'https:']
  const defaultProtocol = 'https:'

  const regexUrl = new RegExp('^(?:[a-z+]+:)?//', 'i')

  if (regexUrl.test(urlRaw)) {
    let url
    try {
      url = new URL(urlRaw)
      if (!validProtocols.includes(url.protocol)) {
        const fixedUrl = urlRaw.replace(/^[^:]+:/, defaultProtocol)
        url = new URL(fixedUrl)
      }
    } catch {
      url = new URL('https://' + urlRaw)
    }
    return url.toString()
  } else {
    return parsePublicUrls(urlRaw)
  }
}
